import { createReducer, on, Action } from '@ngrx/store';
import { LoadState } from '@nx-ng/types';
import { CustomerStoreActions } from '../../actions';
import { IMTicketVerify, ISwiftVerify } from '../../types';

export interface IVerificationState {
  swiftVerify: ISwiftVerify;
  mobileAppVerify: IMTicketVerify;
}

export const initialState: IVerificationState = {
  swiftVerify: {
    loaded: LoadState.NOT_LOADED,
  },

  mobileAppVerify: {
    loaded: LoadState.NOT_LOADED,
  },
};

const dataAccessCustomerDetailsReducer = createReducer(
  initialState,
  on(
    CustomerStoreActions.customerAPI_verifySwiftCard,
    (state, { cardNumber }) => ({
      ...state,
      swiftVerify: {
        ...state.swiftVerify,
        cardNumber,
        loaded: LoadState.LOADING,
        error: undefined,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_verifySwiftCardSuccess,
    (state, { verified }: { verified: boolean }) => ({
      ...state,
      swiftVerify: {
        ...state.swiftVerify,
        loaded: LoadState.LOADED,
        verified,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_verifySwiftCardFailure,
    (state, { error }) => ({
      ...state,
      swiftVerify: {
        ...state.swiftVerify,
        loaded: LoadState.FAILED,
        error,
        verified: false,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_verifyMobileApp,
    (state, { emailAddress }) => ({
      ...state,
      mobileAppVerify: {
        ...state.mobileAppVerify,
        emailAddress,
        loaded: LoadState.LOADING,
        error: undefined,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_verifyMobileAppSuccess,
    (state, { verified }) => ({
      ...state,
      mobileAppVerify: {
        ...state.mobileAppVerify,
        loaded: LoadState.LOADED,
        verified,
      },
    })
  ),
  on(
    CustomerStoreActions.customerAPI_verifyMobileAppFailure,
    (state, { error }) => ({
      ...state,
      mobileAppVerify: {
        ...state.mobileAppVerify,
        loaded: LoadState.FAILED,
        verified: false,
        error,
      },
    })
  )
);

export function reducer(state: IVerificationState | undefined, action: Action) {
  return dataAccessCustomerDetailsReducer(state, action);
}
